module.exports = __webpack_public_path__ + "img/40_38_031_950.86340b88.jpg";